import { HostingFormValidationSchema } from '../../../hostings.interfaces';

export const hostingsFormValidationSchema: HostingFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву реєстратора домену' },
    { type: 'string', message: 'Хостинг має бути строкою' },
    { min: 1, max: 255, message: 'Хостинг має бути довжиною не менше 1 символа та не більше 255' }
  ],
  link: [
    { required: true, message: 'Введіть посилання на реєстратор домену' },
    { type: 'url', message: 'Посилання має бути URl адресою' },
    { min: 1, max: 255, message: 'Посилання має бути довжиною не менше 1 символа та не більше 255' }
  ]
};
